module.exports = __webpack_public_path__ + "static/img/wx-chat.578c632.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/wx-chat.png
// module id = 1219
// module chunks = 153